@defer (when isTopocareReady()) {
  <ng-container *transloco="let t">
    <pxc-topocare
      #ref
      class="-mx-(--dialog-padding) -mt-(--dialog-padding) flex-1"
      [availableModelIds]="availableModelIds"
      (zone-selection-change)="onZoneSelectionChange($event.detail)" />

    <div class="flex gap-2 max-md:flex-col-reverse md:items-center">
      <button appearance="outline" class="md:mr-auto" tuiButton type="button" (click)="cancel()">
        {{ t('Annuler') }}
      </button>
      <button tuiButton type="button" [disabled]="localizationControl.invalid" (click)="confirm()">
        {{ t('Confirmer') }}
      </button>
    </div>
  </ng-container>
} @loading {
  <pxc-spinner />
} @error {
  <p *transloco="let t" class="text-text-error-primary">{{ t('Une erreur est survenue') }}</p>
}
